import { client } from '../../../apollo'
import {
  getRetailerLoyaltyThreshold,
  GetRetailerLoyaltyThresholdResponse,
  GetRetailerLoyaltyThresholdResult,
} from '../../../queries/loyalty-threshold'

/**
 * Get the current retailer loyalty settings.
 *
 * @return {Promise} A promise resolved with the retailer's loyalty settings from the server
 *
 * */
export function get(): Promise<GetRetailerLoyaltyThresholdResponse> {
  return client.query<GetRetailerLoyaltyThresholdResult>({
    query: getRetailerLoyaltyThreshold,
    fetchPolicy: 'network-only',
  })
}
